function pipe(arrayOfFunctions) {
  return function (val) {
    if (!arrayOfFunctions || !Array.isArray(arrayOfFunctions)) {
      return val;
    }

    return arrayOfFunctions.reduce((accumulator, currentFunction) => {
      if (typeof currentFunction === 'function') {
        return currentFunction(accumulator);
      }
      return accumulator;
    }, val);
  };
}

export default {
  pipe,
};
